export default "__VITE_ASSET__6a6de467__"